import { fg } from '@atlassian/jira-feature-gating';

const Wi2PerfSmartLinks = {
	get(): boolean {
		return fg('wi2-perf-smart-links');
	},
};

export default Wi2PerfSmartLinks;
